<template>
  <Head title="LockStep" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center px-4">
        <div class="col-12">
          <LockstepComponent :client="lockstepData.client"></LockstepComponent>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';
import LockstepComponent from '../../components/lockstep/Lockstep.vue';
import { useLockstepStore } from '../../stores/lockstep';
import { useClientStore } from '../../stores/client';

const props = defineProps({
  client: Object,
  lockstep: Object
});

const lockstepData = props.lockstep;

// Set window globals immediately for legacy component compatibility
window.__CLIENT__ = props.client;
window.__LOCKSTEP__ = lockstepData;
window.clientTasks = lockstepData.tasks || [];

// Initialize stores directly
const lockstepStore = useLockstepStore();
const clientStore = useClientStore();

clientStore.setClient(props.client);
lockstepStore.initialize(lockstepData);
</script>

